import React from 'react';
import PropTypes from 'prop-types';
import SidePanelTab from './SidePanelTab';
import RecipientManagerConstants from './RecipientManagerConstants';

export default class RecipientManagerHeader extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="header-container">
          <div className="side-panel-tab-container left">
            <SidePanelTab
              name="Add Recipients"
              imageSrc="/images/self-serve-builder/side-panel/recipients-icon-default-2x.png"
              imageSrcHover="/images/self-serve-builder/side-panel/recipients-icon-active-2x.png"
              tabType={RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW}
              activeTab={this.props.activeTab}
            />
          </div>
          <div className="side-panel-tab-container right">
            <SidePanelTab
              name="Share Link"
              imageSrc="/images/self-serve-builder/side-panel/share-link-icon-default-2x.png"
              imageSrcHover="/images/self-serve-builder/side-panel/share-link-icon-active-2x.png"
              tabType={RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_TAB_SHOW}
              activeTab={this.props.activeTab}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RecipientManagerHeader.propTypes = {
  activeTab: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerHeader.jsx